<!-- 中奖查询 -->
<template>
  <div class="win_content">
    <div class="w_title">
      <img @click="toSetting()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="title_text">中奖查询</span>
    </div>
    <!-- 查询区 -->
    <div class="w_search">
      <input-form ref="awardRef" :inputData="inputAwardTwo" @toParentVal="searchAwardOne"
        :btnPosition1="true"></input-form>
    </div>
    <!-- 表格 -->
    <div class="w_table">
      <!-- 表格 -->
      <el-table v-loading="loading" :data="getRecordList" style="width: 100%;"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }">
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column prop="pin" label="用户pin（加密）" width="150">
        </el-table-column>
        <el-table-column prop="memberNick" label="用户昵称">
        </el-table-column>
        <el-table-column prop="activityName" label="活动名称">
        </el-table-column>
        <el-table-column prop="activitySubType" label="活动类型">
          <template slot-scope="scope">
            <span>{{ getActivityType(scope.row.activitySubType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="prizeType" label="奖品类型">
          <template slot-scope="scope">
            <span>{{getPrizeTypeName(scope.row.prizeType)}}</span>
            <!-- <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
            <span v-else-if="scope.row.prizeType == 2"> 京豆 </span>
            <span v-else-if="scope.row.prizeType == 3"> 实物 </span>
            <span v-else-if="scope.row.prizeType == 4"> 店铺积分 </span>
            <span v-else-if="scope.row.prizeType == 5"> 京东E卡 </span>
            <span v-else-if="scope.row.prizeType == 6"> 爱奇艺会员 </span>
            <span v-else-if="scope.row.prizeType == 7"> 京豆PlUS会员 </span>
            <span v-else-if="scope.row.prizeType == 8"> 现金红包 </span>
            <span v-else-if="scope.row.prizeType == 10"> 礼品卡 </span>
            <span v-else> - </span> -->
          </template>
        </el-table-column>
        <el-table-column prop="prizeName" label="奖品名称">
          <template slot-scope="scope">
            <span v-if="scope.row.prizeName"> {{ scope.row.prizeName }} </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column prop="joinTime" label="参与时间">
          <template slot-scope="scope">
            <span v-if="scope.row.joinTime">{{ scope.row.joinTime }} </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column prop="winTime" label="领奖时间">
          <template slot-scope="scope">
            <span v-if="scope.row.winTime">{{ scope.row.winTime }} </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column prop="grantTime" label="发放时间">
          <template slot-scope="scope">
            <span v-if="scope.row.grantTime">{{ scope.row.grantTime }} </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="中奖状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == -1">待领取</span>
            <span v-if="scope.row.status == 1">未中奖</span>
            <span v-if="scope.row.status == 2">已中奖</span>
            <span v-if="scope.row.status == 3 || scope.row.status == 5 || scope.row.status == 6">已发放</span>
            <span v-if="scope.row.status == 4">发放失败</span>
            <span v-if="scope.row.status == 7">待发放</span>
            <span v-if="scope.row.status == 8">已失效</span>
            <el-tooltip class="item" effect="light"
              v-if="scope.row.failReason && scope.row.status == 4 || scope.row.failReason && scope.row.status == 8"
              :content="scope.row.failReason" placement="bottom">
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question" style="color: #ccc;"></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格分页 -->
      <el-pagination style="text-align: right; margin: 20px 0 0 0" @size-change="handleSizeExchangeRecord" background
        @current-change="handleCurrentExchangeRecord" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="size"
        layout="total, sizes, prev, pager, next, jumper" :total="totalRecord" :current-page="current"></el-pagination>
    </div>
  </div>
</template>

<script>
import statisticsData from "@/mixin/activity_statistics.js";
import inputForm from "../../components/inputForm.vue";
import { getWinRecordByPin } from "@/api/paradiseAndTaskCommonController.js";
export default {
  mixins: [statisticsData],
  components: {
    inputForm
  },
  data() {
    return {
      loading: false,
      inputAwardTwo: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入用户PIN",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "未中奖", id: "1" },
            { label: "待领取", id: "-1" },
            { label: "已中奖", id: "2" },
            { label: "待发放", id: "7" },
            { label: "已发放", id: "3,5,6" },
            { label: "已失效", id: "8" },
            { label: "发放失败", id: "4" },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "优惠券", id: "1" },
            { label: "京豆", id: "2" },
            { label: "实物", id: "3" },
            { label: "店铺积分", id: "4" },
            { label: "京东E卡", id: "5" },
            { label: "爱奇艺会员", id: "6" },
            { label: "PLUS会员", id: "7" },
            { label: "现金红包", id: "8" },
            { label: "礼品卡", id: "10" },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["joinTimeStart", "joinTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "领奖时间:",
          myDate: true,
          val: ["winTimeStart", "winTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发放时间:",
          myDate: true,
          val: ["grantTimeStart", "grantTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        }
      ],
      getRecordList: [],
      formListRecord: {
        pin: "",
        memberNick: "",
        status: "",
        prizeType: "",
        joinTimeStart: '',
        joinTimeEnd: '',
        winTimeStart: '',
        winTimeEnd: '',
        grantTimeStart: '',
        grantTimeEnd: '',
      },
      current: 1,
      size: 10,
      totalRecord: 0
    }
  },
  methods: {
    getInfo() {
      let params = { ...this.formListRecord, size: this.size, current: this.current }
      console.log("params>>>", params);
      // 用户 pin或 昵称至少输入一个
      if (!params.pin && !params.memberNick) {
        this.$message({ type: 'warning', message: '请输入用户PIN或用户昵称进行查询' })
        return
      }
      this.loading = true
      getWinRecordByPin(params).then(res => {
        this.loading = false
        console.log("------getWinRecordByPin----res", res)
        if (res.code == 200 || res.code == 1) {
          this.getRecordList = res.data.records.map(item => {
            return { ...item, pin: item.pin[0] + "*" + item.pin[item.pin.length - 1] }
          })
          this.totalRecord = Number(res.data.total)
        }
      }).catch(err => {
        this.loading = false
      })
    },
    // 查询按钮点击事件
    searchAwardOne(val, type) {
      this.size = 10
      this.current = 1
      this.totalRecord = 0
      const { pin, memberNick, status, prizeType, joinTimeStart, joinTimeEnd, winTimeStart, winTimeEnd, grantTimeStart, grantTimeEnd } = val
      this.formListRecord = { pin, memberNick, status, prizeType, joinTimeStart, joinTimeEnd, winTimeStart, winTimeEnd, grantTimeStart, grantTimeEnd };
      if (type == "reset") {
        this.getRecordList = []
      } else {
        this.getInfo()

      }
    },
    // 查询 size变更
    handleSizeExchangeRecord(size) {
      this.size = size
      this.getInfo(); // 重新查询
      console.log("-------size------", this.size)
    },
    // 查询 页面变更
    handleCurrentExchangeRecord(current) {
      this.current = current
      this.getInfo(); // 重新查询
      console.log("-----current------", this.current)
    },
    // 返回按钮等点击事件
    toSetting() {
      // 返回后刷新 this.$emit("returnBack",true);
      this.$emit("returnBack", true);
    },
    getPrizeType(type) {
      const prizeTypes = {
        1: "优惠券",
        2: "京豆",
        3: "实物",
        4: "店铺积分",
        5: "京东E卡",
        6: "爱奇艺会员",
        7: "京豆PLUS会员",
        8: "现金红包",
        10: "礼品卡"
      };
      return prizeTypes[type] || "-";
    },
    getActivityType(type) {
      let activityTypes = {
        1: "日历签到",
        2: "浏览礼品有礼",
        3: "每日限时抢",
        4: "关注店铺有礼",
        5: "邀请开卡有礼",
        6: "邀请关注有礼",
        7: "完善信息有礼",
        8: "大转盘抽奖",
        9: "积分兑换实物",
        10: "积分兑换优惠券",
        11: "新人优惠券",
        12: "会员优惠券",
        13: "开卡礼包",
        14: "店铺礼包",
        15: "店铺礼包（千人千面）",
        16: "下单有礼",
        17: "首单专享礼",
        18: "复购有礼",
        19: "下单抽奖",
        20: "评价有礼",
        21: "裂变神券",
        22: "天降红包雨",
        23: "欢乐娃娃机",
        24: "大家来找茬",
        25: "智能活动海报",
        26: "刮刮乐",
        27: "预售有礼",
        28: "预售抽奖",
        29: "积分兑换京豆",
        30: "积分兑换E卡",
        31: "超级裂变券",
        32: "会员卡片",
        33: "0元试用",
        34: "加购有礼",
        35: "积分确权活动",
        36: "下单冲榜",
        37: "派样回购礼",
        38: "积分兑换红包",
        39: "生日有礼",
        40: "专属赠品礼",
        41: "晒单有礼",
        42: "派样回购礼（随单发）",
        43: "N元锁权"
      };
      return activityTypes[type] || "-";
    }
  }
}
</script>

<style lang="scss" scoped>
.win_content {
  height: 100%;
  overflow: auto;
  // padding: 0 0px 0px 0px;
  background-color: white;
  margin: 24px;

  .w_title {
    display: flex;
    align-items: center;
    height: 70px;
    padding-left: 28px;
    border-bottom: 1px solid #f2f2f2;

    img {
      cursor: pointer;
    }

    .title_text {
      font-size: 18px;
      font-weight: 600;
      margin-left: 10px;
    }
  }

  .w_search {
    width: 100%;
    margin: 24px 0;
  }

  .w_table {
    padding: 20px 24px;
  }

}
</style>